"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Plugin = void 0;
/**
 * The plugin instance.
 */
var Plugin = /** @class */ (function () {
    function Plugin() {
        this._env = {
            query: {},
            mutation: {},
        };
    }
    /**
     * Load module enviroment to be used
     *
     * @param env module enviroment to be set inside plugin
     */
    Plugin.prototype.loadEnv = function (env, module) {
        this._env[module] = env;
    };
    /**
     * Get module environment
     */
    Plugin.prototype.getEnv = function (module) {
        return this._env[module];
    };
    return Plugin;
}());
exports.Plugin = Plugin;
//# sourceMappingURL=Plugin.js.map